import getValue from "just-safe-get";

// Matches `${this.foo}` and `${foo}` and captures the path without `this.`
const PATH_REGEX = /\${(?:this\.)?([^{}]*)}/;

export function interpolateString(template: string, data: Record<string, any>) {
  return template?.replace(new RegExp(PATH_REGEX, "g"), (_, path) => {
    return getValue(data, path) ?? path.split(".").at(-1) ?? "?";
  });
}

export function getVariable<T>(template: string | undefined, data: Record<string, any>) {
  if (!template) {
    return null;
  }

  const match = template.match(PATH_REGEX);

  if (!match) {
    return null;
  }

  return (getValue(data, match[1]) as T | undefined) ?? null;
}
